export const MODAL_ZINDEX_MIN = 100;
export const MODAL_ZINDEX_MAX = 1000;
